// /pricing — real route (design doc's G1/G4, public surface). The original
// (app/pricing/page.tsx) is an async SERVER component (`auth()` +
// `db.query.users` read for the current plan, plus Next `metadata` +
// inline JSON-LD SEO). No client sibling existed, so this is a small client
// rewrite (apps/spa/app/pricing/page.tsx) that fetches the plan from the
// already-ported `GET /api/stripe/portal` instead of reading the DB
// directly — see that file's header comment for the full rationale. Public,
// no guard (matches core.tsx's ownership: fully public surfaces only).
// Registered into the route tree from routes/core.tsx.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

const PricingPage = lazy(() => import('@/app/pricing/page'));

export const pricingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pricing',
  component: PricingPage,
});
